import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Field, Form, FormGroup, Radio, RadioGroup } from '@availity/form';
import '@availity/yup';
import { ResourceSelect, SelectField } from '@availity/select';
import { DateField } from '@availity/date';
import { Row, Col, Button, Label, UncontrolledTooltip, UncontrolledAlert } from 'reactstrap';
import * as yup from 'yup';
import { Navigate } from 'react-router-dom';
import moment from 'moment';
import PropTypes from 'prop-types';
import axios from 'axios';
import AvApi from '@availity/api-axios';
import ReimbursementStore from '../stores/ReimbursementStore';
import withNavigate from '../../Common/components/withNavigate';
import CustomProgressBar from '../CustomProgressBar/CustomProgressBar';



@observer
 class ReimbursementForm extends Component {
    
    constructor(props) {
        super(props);
    
        this.state = {    
          userInput: '',
          enableProviderAgency: false,
          showInfo: false
        }
    }

        onChangeProvAgencyName = (selectedProvAgencyName) => {
            if (ReimbursementStore.getDocumentsCount() && ReimbursementStore.providerInfo.agencyName.label != selectedProvAgencyName.label){
                ReimbursementStore.resetAllDocumentObj();
                this.setState({showInfo: true});
            }

            if (selectedProvAgencyName) {
          ReimbursementStore.setProviderInfo('agencyName', selectedProvAgencyName);
            }
        }


    componentDidMount () {
        axios.post('/tapreimbursementrequestform/wa/api/v1/provconn/provider/agency/lookup',
			{
				q: "verify",
				limit: 1,
				offset: 0,
				searchKey: "verify"
			})
				.then(res => {
					this.setState({ enableProviderAgency: true });
				}).catch(error => {
					if(error.response.status === 404){
						this.setState({ enableProviderAgency: false });
					}
				});
       
        if (ReimbursementStore.getCountyListCount() === 0) {
			const URL = "/tapreimbursementrequestform/wa/configupdate/assessment.config";
			axios({
				method: 'get',
				url: URL,
			})
				.then(function (response) {
					ReimbursementStore.setCountyList(response.data["assessment.config"][0].codeValues);
				})
				.catch(function (error) {
					return error;
				});
		}

        if (window.performance) {
            if (performance.navigation.type == 1) {
                const contextPath = window.location.pathname;
                window.location.href = contextPath;
            }
        }

        // keep the user on the same page on browser back button/arrow click
        window.onpopstate = () => {
            this.props.navigate(1);
        }
    }

    setProviderInfo = event => {
        const { name, value } = event.target;
        ReimbursementStore.setProviderInfo(name, value);
    }

    setEnrolleeInfo = event => {
        const { name, value } = event.target;
        ReimbursementStore.setEnrolleeInfo(name, value);
    }

    setEnrolleeDOB = value => {
        ReimbursementStore.setEnrolleeDOB(value);
    }

    setEnrolleeGender = value => {
        ReimbursementStore.setEnrolleeGender(value);
    }

    setMedicaidEligibility = value => {
        ReimbursementStore.setMedicaidEligibility(value);
    }

    setrecipientAidCatCode = value => {
        ReimbursementStore.setrecipientAidCatCode(value);
    }

    setEnrolleTribeRadio = value => {
        ReimbursementStore.setEnrolleTribeRadio(value);
    }

    setHousingInfoStatus = value => {
        ReimbursementStore.setHousingInfoStatus(value);
    }

    setHousingSizeStatus = value => {
        ReimbursementStore.setHousingSizeStatus(value);
    }

    setHousingInfoExitingInstitutionRadio = value => {
        ReimbursementStore.setHousingInfoExitingInstitutionRadio(value);
    }

    setHousingInfoTypeOfInstitution = value => {
        ReimbursementStore.setHousingInfoTypeOfInstitution(value);
    }

    setHousingInfoCounty = value => {
        ReimbursementStore.setHousingInfoCounty(value);
    }

    setHousingInfoRegion = event => {
        const { value } = event.target;
        ReimbursementStore.setHousingInfoRegion(value);
    }

    setAuthStartDate = value => {
        ReimbursementStore.setAuthStartDate(value);
    }

    setAuthEndDate = value => {
        ReimbursementStore.setAuthEndDate(value);
    }

    setTreatmentNeed = value => {
        ReimbursementStore.setTreatmentNeed(value);
    }

    reset = () => {
        ReimbursementStore.resetReimbursementForm();
    }

    submit = () => {
        const { navigate } = this.props;
        ReimbursementStore.setReimbursementPageStatus("#reimbursementform", 'complete');
        navigate('/expendituresinfo');
    }

    backNavigation = () => {
        const { navigate } = this.props;
        navigate('/');
    }

    render() {
        const { userAgent } = navigator;

        const {
            providerInfo,
            enrolleeInfo,
            genderTypes,
            medicaidEligibilities,
            recipientAidCatCodes,
            housingInfo,
            housingInfoStatuses,
            housingSizeStatuses,
            typeOfInstitutions,
            countyRegions,
            countyList,
            treatmentNeeds,
            reimbursementFormPages
        } = ReimbursementStore;

        const {
            enableProviderAgency,
             userInput,
             showInfo
        }=this.state;

        const provAgencyNameApi = new AvApi({
			api: '',
			url: '/tapreimbursementrequestform/wa/api/v1/provconn/provider/agency/lookup',
			transformRequest: (options) => JSON.stringify(options),
		});

        return (
            <>
                <CustomProgressBar pages={reimbursementFormPages} page="#reimbursementform"/>
                <div className="border-form">
                    <small className="required-fields">*required</small>
                    <div className="spacer-48" />
                    <h2 className="poppinsH2">
                        Provider & Enrollee Information
                    </h2>
                    <div className="spacer-48" />
                    <Form
                        onSubmit={this.submit}
                        enableReinitialize
                        initialValues={{

                            agencyName: providerInfo.agencyName,
                            npi: providerInfo.npi,
                            contactName: providerInfo.contactName,
                            contactPhone: providerInfo.contactPhone,
                            contactEmail: providerInfo.contactEmail,
                            enrolleFirstName: enrolleeInfo.firstName,
                            enrolleMiddleInitial: enrolleeInfo.middleInitial,
                            enrolleLastName: enrolleeInfo.lastName,
                            enrolleDOB: enrolleeInfo.dob,
                            enrolleGender: enrolleeInfo.gender,
                            enrolleProvOneId: enrolleeInfo.providerOneId,
                            enrolleMedEligibility: enrolleeInfo.medicaidEligibility,
                            enrolleAidCatCode: enrolleeInfo.recipientAidCatCode,
                            enrolleTribeRadio: enrolleeInfo.tribe,
                            enrolleTribeField: enrolleeInfo.tribeDetails,
                            housingInfoStatus: housingInfo.status,
                            housingInfoExitingInstitutionRadio: housingInfo.exitingInstitution,
                            housingInfoTypeOfInstitution: housingInfo.typeOfInstitution,
                            housingInfoCounty: housingInfo.county,
                            housingSizeStatus:housingInfo.housingSize,
                            housingInfoRegion: housingInfo.region,
                            authStartDate: housingInfo.authStartDate,
                            authEndDate: housingInfo.authEndDate,
                            treatmentNeed: housingInfo.treatmentNeed,
                            enrollePreferName : enrolleeInfo.preferredName
                        }}
                        validationSchema={yup.object().shape({
                            agencyName:enableProviderAgency ? yup.object().required('Provider Agency Name is required.') : yup
                            .string().required('Provider Agency Name is required'),
                            npi: yup
                                .string()
                                .required('NPI is required')
                                .matches(/^\d{10}$/, 'NPI must be 10 digits'),
                            contactName: yup
                                .string()
                                .required('Contact Name is required')
                                .matches(/^[A-Za-z0-9 \',\^\-&ÄäÖöÜü]+$/, 'Contact Name is invalid'),
                            contactPhone: yup
                                .string()
                                .required('Contact Phone is required')
                                .matches(/^\d{10}$/, 'Contact Phone must be 10 digits'),
                            contactEmail: yup
                                .string()
                                .required('Contact Email is required'),
                            enrolleFirstName: yup
                                .string()
                                .required('First name is required')
                                .matches(/^[A-Za-z0-9 \',\^\-&ÄäÖöÜü]+$/, 'First name is invalid'),
                            enrollePreferName: yup
                                .string()
                                .matches(/^[A-Za-z0-9 \',\^\-&ÄäÖöÜü]+$/, 'Preferred name is invalid'),
                            enrolleMiddleInitial: yup
                                .string()
                                .matches(/[A-Za-z]$/, 'No numbers or special characters allowed!'),
                            enrolleLastName: yup
                                .string()
                                .required('Last name is required')
                                .matches(/^[A-Za-z0-9 \',\^\-&ÄäÖöÜü]+$/, 'Last name is invalid'),
                            enrolleDOB: yup
                                .date()
                                .max(moment().format('MM/DD/YYYY'), 'Date Of Birth cannot be in future')
                                .required('Date of Birth is required')
                                .typeError('Date of Birth is invalid'),
                            enrolleGender: yup
                                .string()
                                .required('Gender is required'),
                            enrolleProvOneId: yup
                                .string()
                                .required('ProviderOne id is required')
                                .matches(/^\d{9}$/, 'ProviderOne Id should be only 9 digits, no special characters or alphabets!'),
                            enrolleMedEligibility: yup
                                .string()
                                .required('Medicaid Eligibility is required'),
                            enrolleAidCatCode: yup
                                .string()
                                .required('Recipient Aid Category (RAC) Code is required'),
                            enrolleTribeField:
                                enrolleeInfo.tribe === 'Yes' && !enrolleeInfo.tribeDetails ?
                                    yup
                                        .string()
                                        .required('Please specify the tribe before continuing!')
                                    :
                                    yup
                                        .string(),
                            housingInfoStatus: yup
                                .string()
                                .required('Housing Status is required'),
                            housingSizeStatus: yup
                            .string()
                            .required('Housing Size is required'),
                            housingInfoExitingInstitutionRadio: yup
                                .string()
                                .required('required!'),
                            housingInfoTypeOfInstitution:
                                housingInfo.exitingInstitution === 'Yes' ?
                                    yup
                                        .string()
                                        .required('required!')
                                    :
                                    yup
                                        .string(),
                            housingInfoCounty: yup
                                .string()
                                .required('County is required'),
                            housingInfoRegion:
                                housingInfo.county === 'Other' ?
                                    yup
                                        .string()
                                        .required('Region is required')
                                    :
                                    yup
                                        .string(),
                             authStartDate: yup
                                .date()
                                .required('Supportive Housing Auth Start Date is required')
                                .typeError('Supportive Housing Auth Start Date is invalid'),
                            authEndDate: yup
                                .date()
                                .nullable()
                                .when("authStartDate", (authStartDate, schema) => {
                                    if (authStartDate && moment(authStartDate).isValid()) {
                                        return schema.min(authStartDate,
                                            `Supportive Housing Auth End Date must be after ${moment(authStartDate).format('MM/DD/YYYY')}`)
                                            .required('Supportive Housing Auth End Date is required')
                                            .typeError('Supportive Housing Auth End Date is invalid')
                                    }
                                    return schema.typeError('');
                                }),
                            treatmentNeed: yup
                                .string()
                                .required('required!')
                        })}
                    >
                        <h2 className="poppinsH2">
                            <b>Provider Information</b>
                        </h2>
                        <div className="spacer-24" />
                        {showInfo  &&
							<Row className="pl-32 mt-3">
								<Col>
									<UncontrolledAlert color='danger' fade>
										<strong>
											Change in Provider Agency required all the docs to upload again..!
										</strong>
									</UncontrolledAlert>
								</Col>
							</Row>
						}
                        <Row>
                            <Col className="pl-15 max-width-22" sm="3">
                                {enableProviderAgency ? 
                    <ResourceSelect
                      label={
                        <>
                          <Label id="providerAgencyField-label" htmlFor="providerAgencyField">
                            Provider Agency Name*
                            <span id="providerAgencyField-help" className="inline-help" />
                          </Label>
                          <div id="providerAgencyNameHelp">
                            <small className='form-text text-muted prov-agency-name-help'>
                              Enter minimum 3 characters and continue to find the exact match.
                            </small>
                          </div>
                          <UncontrolledTooltip target="providerAgencyField-help" placement="right" innerClassName="text-left">
                            Enter minimum 3 characters and continue to find the exact match.
                          </UncontrolledTooltip>
                        </>
                      }
                      id="provAgencyNameId"
                      name="agencyName"
                      className='straighten-borders'
                      placeholder="Select Provider Agency Name"
                      onChange={this.onChangeProvAgencyName}
                      resource={provAgencyNameApi}
                      shouldSearch={(_inputValue) => _inputValue.length > 2}
                      onInputChange={(searchInput) => this.setState({ userInput: searchInput })}
                      parameters={{
                        searchKey: `${userInput}`,
                        formType: 'TAP'
                      }}
                      waitUntilFocused
                      getResult={(data) =>
                        data.names.map((val) => ({
                          value: val.id,
                          label: val.name,
                          abbr: val.abbr
                        }))
                      }
                      method='POST'
                    />
								  :
                    <>
                      <Label className="label-font" htmlFor="providerAgency">
                        Provider Agency Name*
                      </Label>
                      <Field
                        type="text"
                        id="providerAgency"
                        name="agencyName"
                        className="straighten-borders"
                        value={providerInfo.agencyName}
                        onChange={this.setProviderInfo}
                        maxLength={100}
                      />
                    </>
                  }
                
                            </Col> 
                            <Col className="pl-10 max-width-12-5 fields" sm="3"> 
                                <FormGroup for="npi" className="label-font">
                                    <Label for="npi" id="npiLabel">
                                        NPI*
                                        <span id="npi-help" className="inline-help" />
                                    </Label>
                                    <UncontrolledTooltip target="npi-help" placement="right"
                                        innerClassName="text-left">
                                        {`Your organization’s 10-digit contracted facility National Provider Identifier (NPI)`}
                                    </UncontrolledTooltip>
                                    <Field
                                        type="text"
                                        id="npi"
                                        name="npi"
                                        className="straighten-borders"
                                        maxLength={10}
                                        value={providerInfo.npi}
                                        onChange={this.setProviderInfo}
                                    />
                                </FormGroup>
                            </Col>
                            <Col className="pl-10 max-width-22 fields" sm="3">
                                <FormGroup for="contactName" className="label-font">
                                    <Label for="contactName" id="contactNameLabel">
                                        Contact Name*
                                        <span id="contactName-help" className="inline-help" />
                                    </Label>
                                    <UncontrolledTooltip target="contactName-help" placement="right"
                                        innerClassName="text-left">
                                        {`Name of contact person at provider agency submitting the FCS TAP request`}
                                    </UncontrolledTooltip>
                                    <Field
                                        type="text"
                                        id="contactName"
                                        name="contactName"
                                        className="straighten-borders"
                                        value={providerInfo.contactName}
                                        onChange={this.setProviderInfo}
                                        maxLength={100}
                                    />
                                </FormGroup>
                            </Col>
                            <Col className="pl-10 max-width-17 fields" sm="3">
                                <FormGroup for="contactPhone" className="label-font">
                                    <Label for="contactPhone">
                                        Contact Phone*
                                    </Label>
                                    <Field
                                        type="text"
                                        id="contactPhone"
                                        name="contactPhone"
                                        className="straighten-borders"
                                        maxLength={10}
                                        value={providerInfo.contactPhone}
                                        onChange={this.setProviderInfo}
                                    />
                                </FormGroup>
                            </Col>
                            <Col className="pl-10 fields" sm="3">
                                <FormGroup for="contactEmail" className="label-font">
                                    <Label for="contactEmail">
                                        Contact Email*
                                    </Label>
                                    <Field
                                        type="text"
                                        id="contactEmail"
                                        name="contactEmail"
                                        className="straighten-borders"
                                        value={providerInfo.contactEmail}
                                        onChange={this.setProviderInfo}
                                        maxLength={50}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <div className="spacer-48" />

                        <h2 className="poppinsH2">
                            <b>Enrollee Information</b>
                        </h2>

                        <div className="spacer-24" />

                        <Row>
                            <Col className="pl-15 pr-6" sm="5">
                                <FormGroup for="enrolleFirstName" className="label-font">
                                    <Label for="enrolleFirstName">
                                        First Name*
                                    </Label>
                                    <Field
                                        type="text"
                                        id="enrolleFirstName"
                                        name="enrolleFirstName"
                                        className="straighten-borders"
                                        value={enrolleeInfo.firstName}
                                        onChange={this.setEnrolleeInfo}
                                        maxLength={50}
                                    />
                                </FormGroup>
                            </Col>
                            <Col className="pl-4 pr-0" sm="2">
                                <FormGroup for="enrolleMiddleInitial" className="label-font">
                                    <Label for="enrolleMiddleInitial">
                                        Middle Initial
                                    </Label>
                                    <Field
                                        type="text"
                                        id="enrolleMiddleInitial"
                                        name="enrolleMiddleInitial"
                                        className="straighten-borders"
                                        value={enrolleeInfo.middleInitial}
                                        onChange={this.setEnrolleeInfo}
                                        maxLength={1}
                                    />
                                </FormGroup>
                            </Col>
                            <Col className="pl-10 pr-16" sm="5">
                                <FormGroup for="enrolleLastName" className="label-font">
                                    <Label for="enrolleLastName">
                                        Last Name*
                                    </Label>
                                    <Field
                                        type="text"
                                        id="enrolleLastName"
                                        name="enrolleLastName"
                                        className="straighten-borders"
                                        value={enrolleeInfo.lastName}
                                        onChange={this.setEnrolleeInfo}
                                        maxLength={50}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <div className="spacer-30" />

                        <Row>
                        <Col className="pl-15 pr-6" sm="5">
                                <FormGroup for="enrollePreferName" className="label-font">
                                    <Label for="enrollePreferName">
                                    Preferred Name
                                    </Label>
                                    <Field
                                        type="text"
                                        id="enrollePreferName"
                                        name="enrollePreferName"
                                        className="straighten-borders"
                                        value={enrolleeInfo.preferredName}
                                        onChange={this.setEnrolleeInfo}
                                        maxLength={25}
                                    />
                                </FormGroup>
                            </Col>
                            

                            <Col sm="2">
                                         <FormGroup for='enrolleDOB' className='label-font'>
									<DateField
										id='enrolleDOB'
										name='enrolleDOB'
										label='DOB*'
										value={enrolleeInfo.dob}
										className='straighten-borders'
										onChange={this.setEnrolleeDOB}
										datePickerProps={{
											showDefaultInputIcon: true,
											inputIconPosition: 'after',
											autoComplete: /edg/i.test(userAgent) ? 'autofill-off-edge' : 'off',
										}}
									/>
								</FormGroup>
                                   
                            </Col>
                            <Col className="pl-10" sm="1">
                                <FormGroup for="enrolleAge" className="label-font">
                                    <Label for="enrolleAge">
                                        Age
                                    </Label>
                                    <Field
                                        type="text"
                                        id="enrolleAge"
                                        name="enrolleAge"
                                        className="straighten-borders"
                                        value={enrolleeInfo.age}
                                        disabled
                                    />
                                </FormGroup>
                            </Col>
                            <Col className="pl-10" sm="2">
                                <FormGroup for="enrolleGender" className="label-font">
                                    <Label for="enrolleGender">
                                        Gender*
                                        <span id="enrolleGender-help" className="inline-help" />
                                    </Label>
                                    <UncontrolledTooltip target="enrolleGender-help" placement="right"
                                        innerClassName="text-left">
                                        {`M = male; F = female; X = a gender that is not exclusively 
                                        male nor female (i.e., nonbinary, a gender, or gender nonconforming)`}
                                    </UncontrolledTooltip>
                                    <SelectField
                                        name="enrolleGender"
                                        className="straighten-borders pTypeList"
                                        value={enrolleeInfo.gender}
                                        onChange={this.setEnrolleeGender}
                                        options={genderTypes.map(genderType => (
                                            {
                                                value: genderType.value, label: genderType.name
                                            }
                                        ))}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <div className="spacer-30" />

                        <Row>
                            <Col className="pl-15" sm="2">
                                <FormGroup for="enrolleProvOneId" className="label-font">
                                    <Label for="enrolleProvOneId">
                                        ProviderOne ID No.*
                                    </Label>
                                    <Field
                                        type="text"
                                        id="enrolleProvOneId"
                                        name="enrolleProvOneId"
                                        className="straighten-borders"
                                        value={enrolleeInfo.providerOneId}
                                        onChange={this.setEnrolleeInfo}
                                        maxLength={9}
                                    />
                                </FormGroup>
                            </Col>
                            <Col className="plr-0 custom-enrolleStateCode">
                                <FormGroup for="enrolleStateCode" className="label-font">
                                    <Field
                                        type="text"
                                        id="enrolleStateCode"
                                        name="enrolleStateCode"
                                        className="straighten-borders"
                                        value={enrolleeInfo.stateCode}
                                        disabled
                                    />
                                </FormGroup>
                            </Col>
                            <Col className="pl-10" sm="6">
                                <FormGroup for="enrolleMedEligibility" className="label-font">
                                    <Label for="enrolleMedEligibility">
                                        Medicaid Eligibility*
                                        <span id="enrolleMedEligibility-help" className="inline-help" />
                                    </Label>
                                    <UncontrolledTooltip target="enrolleMedEligibility-help" placement="right"
                                        innerClassName="text-left">
                                        {`Enrollee's Medicaid Benefit Service Package. Found on ProviderOne website`}
                                    </UncontrolledTooltip>
                                    <SelectField
                                        name="enrolleMedEligibility"
                                        className="straighten-borders pTypeList"
                                        value={enrolleeInfo.medicaidEligibility}
                                        onChange={this.setMedicaidEligibility}
                                        options={medicaidEligibilities.map(medicaidEligibility => (
                                            {
                                                value: medicaidEligibility.value, label: medicaidEligibility.name
                                            }
                                        ))}
                                    />
                                </FormGroup>
                            </Col>
                            <Col className="pl-10r-15 col-305" sm="4">
                                <FormGroup for="enrolleAidCatCode" className="label-font">
                                    <Label for="enrolleAidCatCode">
                                        Recipient Aid Category (RAC) Code*
                                        <span id="enrolleAidCatCode-help" className="inline-help" />
                                    </Label>
                                    <UncontrolledTooltip target="enrolleAidCatCode-help" placement="right"
                                        innerClassName="text-left">
                                        {`Enrollee's Medicaid Recipient Aid Catergory (RAC). Found on ProviderOne website.`}
                                    </UncontrolledTooltip>
                                    <SelectField
                                        name="enrolleAidCatCode"
                                        className="straighten-borders pTypeList"
                                        value={enrolleeInfo.recipientAidCatCode}
                                        onChange={this.setrecipientAidCatCode}
                                        options={recipientAidCatCodes.map(recipientAidCatCode => (
                                            {
                                                value: recipientAidCatCode.value, label: recipientAidCatCode.name
                                            }
                                        ))}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <div className="spacer-30" />

                        <Row>
                            <Col className="pl-15" sm="5">
                                <FormGroup for="enrolleTribeRadio">
                                    <Label className="label-font" for="enrolleTribeRadio">
                                        Is the enrollee a member of an American Indian/Alaskan Native Tribe?
                                    </Label>
                                    <RadioGroup inline value={enrolleeInfo.tribe} name="enrolleTribeRadio" onChange={this.setEnrolleTribeRadio} >
                                        <Radio className="label-font-round" label="Yes" value="Yes" />
                                        <Radio className="label-font-round" label="No" value="No" />
                                    </RadioGroup>
                                </FormGroup>
                            </Col>
                            <Col className="pl-10t-16" sm="4">
                            {
                                    enrolleeInfo.tribe !== 'Yes' ?
                                        <div className="disableEnrolleTribeField">
                                            <FormGroup for="enrolleTribeField" className="label-font">
                                                <Field
                                                    type="text"
                                                    name="enrolleTribeField"
                                                    id="enrolleTribeField"
                                                    className="straighten-borders"
                                                    label="If yes, please specify which tribe:"
                                                    value={enrolleeInfo.tribeDetails}
                                                    onChange={this.setEnrolleeInfo}
                                                    disabled
                                                />
                                            </FormGroup>
                                        </div>
                                        :
                                        <div>
                                            <FormGroup for="enrolleTribeField" className="label-font">
                                                <Field
                                                    type="text"
                                                    name="enrolleTribeField"
                                                    id="enrolleTribeField"
                                                    className="straighten-borders"
                                                    label="If yes, please specify which tribe:"
                                                    value={enrolleeInfo.tribeDetails}
                                                    onChange={this.setEnrolleeInfo}
                                                />
                                            </FormGroup>
                                        </div>
                                }
                            </Col>
                        </Row>

                        <div className="spacer-48" />

                        <h2 className="poppinsH2">
                            <b>Housing Information</b>
                        </h2>

                        <div className="spacer-24" />

                        <Row>
                            <Col className="pl-15" sm="3">
                                <FormGroup for="housingInfoStatus" className="label-font">
                                    <Label for="housingInfoStatus">
                                        Current Housing Status*
                                    </Label>
                                    <SelectField
                                        name="housingInfoStatus"
                                        className="straighten-borders pTypeList"
                                        value={housingInfo.status}
                                        onChange={this.setHousingInfoStatus}
                                        options={housingInfoStatuses.map(housingInfoStatus => (
                                            {
                                                value: housingInfoStatus.value, label: housingInfoStatus.name
                                            }
                                        ))}
                                    />
                                </FormGroup>
                            </Col>
                            <Col className="pl-10 col-164" sm="3">
                                <FormGroup for="housingInfoExitingInstitutionRadio" className="mb-0">
                                    <Label className="label-font" for="housingInfoExitingInstitutionRadio">
                                        Exiting an Institution?*
                                    </Label>
                                    <RadioGroup
                                        inline
                                        value={housingInfo.exitingInstitution}
                                        name="housingInfoExitingInstitutionRadio"
                                        className="mb-0"
                                        onChange={this.setHousingInfoExitingInstitutionRadio}
                                    >
                                        <Radio className="label-font-round" label="Yes" value="Yes" />
                                        <Radio className="label-font-round" label="No" value="No" />
                                    </RadioGroup>
                                </FormGroup>
                            </Col>
                            <Col className="pl-10" sm="4">
                                {
                                    housingInfo.exitingInstitution !== 'Yes' ?
                                        <div className="disableTypeOfInstitutionField">
                                            <FormGroup for="housingInfoTypeOfInstitution" className="label-font">
                                                <Label for="housingInfoTypeOfInstitution">
                                                    If yes, Type of Institution
                                                </Label>
                                                <SelectField
                                                    name="housingInfoTypeOfInstitution"
                                                    className="straighten-borders pTypeList"
                                                    value={housingInfo.typeOfInstitution}
                                                    onChange={this.setHousingInfoTypeOfInstitution}
                                                    options={housingInfoStatuses.map(housingInfoStatus => (
                                                        {
                                                            value: housingInfoStatus.value, label: housingInfoStatus.name
                                                        }
                                                    ))}
                                                    isDisabled
                                                />
                                            </FormGroup>
                                        </div>
                                        :
                                        <div>
                                            <FormGroup for="housingInfoTypeOfInstitution" className="label-font">
                                                <Label for="housingInfoTypeOfInstitution">
                                                    If yes, Type of Institution*
                                                </Label>
                                                <SelectField
                                                    name="housingInfoTypeOfInstitution"
                                                    className="straighten-borders pTypeList"
                                                    value={housingInfo.typeOfInstitution}
                                                    onChange={this.setHousingInfoTypeOfInstitution}
                                                    options={typeOfInstitutions.map(typeOfInstitution => (
                                                        {
                                                            value: typeOfInstitution.value, label: typeOfInstitution.name
                                                        }
                                                    ))}
                                                />
                                            </FormGroup>
                                        </div>
                                }
                            </Col>
                        </Row>

                        <div className="spacer-30" />

                        <h6><strong>Supportive Housing (SH) Authoritzation Details</strong></h6>
                        <div className="spacer-30" />
                        <Row className='pl-1'>
                            <Col className="pl-15" sm="2">
                                <FormGroup for="authStartDate" className="label-font">
                                    <Label for="authStartDate">
                                        SH Start Date*
                                        <span id="authStartDate-help" className="inline-help" />
                                    </Label>
                                    <UncontrolledTooltip target="authStartDate-help" placement="right"
                                        innerClassName="text-left">
                                        {`Current FCS Supportive Housing service authorization start date`}
                                    </UncontrolledTooltip>
                                    <DateField
                                        type="text"
                                        id="authStartDate"
                                        name="authStartDate"
                                        className="straighten-borders"
                                        value={housingInfo.authStartDate}
                                        onChange={this.setAuthStartDate}
                                        openDirection='down'
                                        datePicker
                                        min={{ value: 99, units: 'year' }}
                                        max={{value: 2, units: 'year'}}
                                    />
                                </FormGroup>
                            </Col>
                            <Col className="pl-10" sm="2">
                                <FormGroup for="authEndDate" className="label-font">
                                    <Label for="authEndDate">
                                        SH End Date*
                                    </Label>
                                    <DateField
                                        type="text"
                                        id="authEndDate"
                                        name="authEndDate"
                                        className="straighten-borders"
                                        value={housingInfo.authEndDate}
                                        onChange={this.setAuthEndDate}
                                        openDirection='down'
                                        datePicker
                                        min={moment(housingInfo.authStartDate).format('MM/DD/YYYY')}
                                        max={{value: 2, units: 'year'}}
                                        disabled={!housingInfo.authStartDate}
                                    />
                                </FormGroup>
                            </Col>
                            <Col className="pl-10" sm="3">
                                <FormGroup for="treatmentNeed" className="label-font">
                                    <Label for="treatmentNeed">
                                        Treatment Need*
                                        <span id="treatmentNeed-help" className="inline-help" />
                                    </Label>
                                    <UncontrolledTooltip target="treatmentNeed-help" placement="right"
                                        innerClassName="text-left">
                                        {`Enrollee’s behavioral health treatment need`}
                                    </UncontrolledTooltip>
                                    <SelectField
                                        name="treatmentNeed"
                                        className="straighten-borders pTypeList"
                                        value={housingInfo.treatmentNeed}
                                        onChange={this.setTreatmentNeed}
                                        options={treatmentNeeds.map(treatmentNeed => (
                                            {
                                                value: treatmentNeed.value, label: treatmentNeed.name
                                            }
                                        ))}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <div className="spacer-30" />

                        <Row className='pl-1'>
                        <Col className="pl-15" sm="3">
                                <FormGroup for="housingSizeStatus" className="label-font">
                                    <Label for="housingSizeStatus">
                                        Housing Size*
                                    </Label>
                                    <SelectField
                                        name="housingSizeStatus"
                                        className="straighten-borders pTypeList"
                                        value={housingInfo.housingSize}
                                        onChange={this.setHousingSizeStatus}
                                        options={housingSizeStatuses.map(housingSizeStatus => (
                                            {
                                                value: housingSizeStatus.value, label: housingSizeStatus.name
                                            }
                                        ))}
                                    />
                                </FormGroup>
                            </Col>
                            <Col className="pl-15" sm="2">
                                <FormGroup for="housingInfoCounty" className="label-font">
                                    <Label for="housingInfoCounty">
                                        County*
                                    </Label>
                                    <SelectField
                                        name="housingInfoCounty"
                                        className="straighten-borders pTypeList"
                                        value={housingInfo.county}
                                        onChange={this.setHousingInfoCounty}
                                        options={countyList.map(county=> (
                                            {
                                                value: county.code, label: county.value
                                            }
                                        ))}
                                    />
                                </FormGroup>
                            </Col>
                            <Col className="pl-10" sm="3">
                                        <FormGroup for="housingInfoRegion" className="label-font">
                                            <Label for="housingInfoRegion">
                                                Region
                                                <span id="housingInfoRegion-help" className="inline-help" />
                                            </Label>
                                            <UncontrolledTooltip target="housingInfoRegion-help" placement="right"
                                                innerClassName="text-left">
                                                {`Region auto populates based on the county selected per Washington Apple Health managed care service area map`}
                                            </UncontrolledTooltip>
                                            <Field
                                                type="text"
                                                id="housingInfoRegion"
                                                name="housingInfoRegion"
                                                className="straighten-borders"
                                                value={housingInfo.region}
                                                disabled
                                            />
                                        </FormGroup>
                                
                            </Col>
                        </Row> 

                        
                        <div className="spacer-48" />

                        <Button type="submit" color={"primary"} className={"btn btn-primary nextBtn"}>
                            Next
                        </Button>

                        <Button type="button" onClick={this.reset} color={"primary"} className={"btn btn-outline-primary clearBtn"}>
                            Clear
                        </Button>

                        <Button type="button" color={"primary"} className={'btn btn-primary backButton'} onClick={this.backNavigation}>
                        Back
                    </Button>

                        <div className="pb-spacerRem-10" />

                    </Form>
                </div>
            </>
        );
    }
}
export default withNavigate(ReimbursementForm);

ReimbursementForm.propTypes = {
    navigate: PropTypes.func
};